import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useTaskStore } from '@/app/store/taskStore';

interface QuickTodoButtonProps {
  className?: string;
  showText?: boolean;
}

export const QuickTodoButton: React.FC<QuickTodoButtonProps> = ({
  className,
  showText = true,
}) => {
  const { openQuickTodoModal } = useTaskStore();

  // Keyboard shortcut: Ctrl+T to open quick todo modal
  useHotkeys('ctrl+t, meta+t', (e) => {
    e.preventDefault();
    openQuickTodoModal();
  }, {
    enableOnFormTags: false,
  });

  const handleClick = () => {
    openQuickTodoModal();
  };

  return (
    <Button
      onClick={handleClick}
      size="sm"
      title="Quick add todo (Ctrl+T)"
      className={`gap-1.5 ${className}`}
    >
      <Plus className="h-4 w-4" />
      {showText && <span className="hidden sm:inline">Add Todo</span>}
    </Button>
  );
};
